module.exports = __webpack_public_path__ + "img/9788942403844.d0714222.jpg";